import { toDayKey } from "../table/filterFns";
import { filtersToSearchParams } from "./urlFilters";

const PRODUCTS_PATH = "/manafix/products";
const LINK_SCHEMA = { status: "list", calculatedDeadline: "date" };
const DESCRIBED_WINDOWS = [7, 15, 30];

/** Dia local (YYYY-MM-DD) de hoje. */
export const todayKey = (now = new Date()) => toDayKey(now);

/** Soma `n` dias a um dia (YYYY-MM-DD ou Date), no calendário local. */
export const addDays = (day, n) => {
    const base = day instanceof Date ? day : new Date(`${day}T12:00:00`);
    const date = new Date(base.getFullYear(), base.getMonth(), base.getDate() + n, 12);
    return toDayKey(date);
};

/** Janela do filtro de Prazo: "overdue" (antes de hoje) ou N dias à frente (inclui atrasados). */
export const deadlineWindowFilter = (kind, now = new Date()) => {
    const today = todayKey(now);
    return { from: "", to: addDays(today, kind === "overdue" ? -1 : Number(kind)) };
};

/** Texto curto para janelas conhecidas; `null` deixa quem chama usar a descrição padrão de datas. */
export const describeDeadlineFilter = (value, now = new Date()) => {
    if (!value || value.from || !value.to) return null;
    if (value.to === deadlineWindowFilter("overdue", now).to) return "atrasados";
    const days = DESCRIBED_WINDOWS.find((n) => value.to === deadlineWindowFilter(n, now).to);
    return days ? `vence em até ${days} dias` : null;
};

/** Link de Pedidos já filtrado. `sort`: "calculatedDeadline" (asc) ou "-calculatedDeadline" (desc). */
export const buildProductsLink = ({ statuses, deadline, sort } = {}) => {
    const filters = [];
    if (statuses?.length) filters.push({ id: "status", value: statuses });
    if (deadline) filters.push({ id: "calculatedDeadline", value: deadline });
    const params = filtersToSearchParams(filters, LINK_SCHEMA);
    if (sort) params.set("sort", sort);
    const query = params.toString();
    return query ? `${PRODUCTS_PATH}?${query}` : PRODUCTS_PATH;
};
